import React from "react";
import CategoryPage from "./CategoryPage";

const CarStickers = () => (
  <CategoryPage
    categoryId="car-stickers"
    categoryTitle="Car Stickers"
    categoryDescription="Stylish and durable car stickers to customize your vehicle. Features premium adhesive, weather-resistant material, and comes in multiple designs. Transform your car's look instantly."
  />
);

export default CarStickers;
